'use client'
import { useState } from 'react'
import { getShareText, getShareUrl } from '@/lib/share'
import styles from './style.module.scss'

type Props = {
  url?: string
  title?: string
}

export function WebShareButton({ url, title }: Props) {
  const [copied, setCopied] = useState(false)

  const handleShare = async () => {
    const shareData = {
      title,
      text: getShareText(title),
      url: getShareUrl(url),
    }

    // Web Share API が使える環境ではシェアUIを表示
    if (navigator.share) {
      try {
        await navigator.share(shareData)
      } catch (error) {
        // ユーザーが共有ダイアログを閉じた場合は何もしない
        if ((error as DOMException).name !== 'AbortError') {
          console.error(error)
        }
      }

      return
    }

    // Web Share API が使えない環境ではURLをコピー
    try {
      await navigator.clipboard.writeText(shareData.url)

      setCopied(true)

      setTimeout(() => {
        setCopied(false)
      }, 2000)
    } catch (error) {
      console.error(error)
    }
  }

  return (
    <a
      type="button"
      onClick={handleShare}
      className={styles.WebShareButton}
      aria-label="シェア"
    >
      {copied ? 'リンクをコピーしました！' : 'シェア'}
    </a>
  )
}
